module.exports = __webpack_public_path__ + "asana-3-4d42bf1f9351655a963d155ca46eab57.webp";